import OrderHostingButton from './OrderHostingButton'

export default OrderHostingButton
